var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.8 12.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #9b9fa4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,3H1.6c-.9,0-1.6.7-1.6,1.6v6.2c0,.9.7,1.6,1.6,1.6h9.6c.9,0,1.6-.7,1.6-1.6v-6.2c0-.9-.7-1.6-1.6-1.6ZM9,8.5c0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0-.1,0h-1.3v1.4c0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0h-1.5c0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,0,0,0,0v-1.4h-1.4c0,0-.1,0-.2,0,0,0,0,0,0,0s0,0,0,0v-1.6c0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,0,0,0h1.4v-1.4c0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,0,.1,0h1.5c0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0v1.4h1.3c0,0,.1,0,.2,0,0,0,0,0,0,0s0,0,0,0v1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,2.8h-.9l-.6-1.6c0-.2-.3-.4-.6-.4h-2.9c-.2,0-.5.2-.6.4l-.6,1.6h-.9l.8-1.9c.2-.5.7-.9,1.3-.9h2.9c.6,0,1.1.4,1.3.9l.8,1.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstaid);
export default __webpack_public_path__ + "static/media/Firstaid.21949a954a0eaaefb53eabb5740d81ba.svg";
export { ForwardRef as ReactComponent };